export default __webpack_public_path__ + "static/media/applestore.e98b702b.svg";